import { useState, useEffect } from "react";
import NiceModal from '@ebay/nice-modal-react';
import ApiModal from '/src/components/modal/ApiModal/ApiModal';
import DashboardVariableFormModal from '../../variable/DashboardVariableFormModal/DashboardVariableFormModal'
import "./DashboardVariable.css";
import '/src/components/UI/Button/IconButton/IconButton.css'
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import { DashboardVariableType } from "../../../variableType"
import DashboardToggle from "./DashboardToggle";
import DashboardInput from "./DashboardInput";
import DashboardDropdown from "./DashboardDropdown";
import DashboardButton from "./DashboardButton/DashboardButton";
import DashboardNumber from "./DashboardNumber";
import dashboardService from '../../../services/dashboardService';
import { isClient, isAdmin } from "/src/utils/access";
import Tooltip from "../../Tooltip/Tooltip";
function DashboardVariable({ dashboard_channel, variable, postbackAction, bot, className, access, index }) {

    const [render, setRender] = useState(false);
    const [type, setType] = useState(0);
    const { editVariable, updateDashboardVariableShared, deleteVariable, updatePositionVariable } = dashboardService;
    const toast = useToastDispatchContext();
    const [hasError, setHasError] = useState(false);

    const [hoverVariable, setHoverVariable] = useState(false);
    const analysisVariable = () => {
        switch (variable.type) {
            case DashboardVariableType.find(type => type.name == "Toggle").value:
                setRender(
                    <DashboardToggle data={variable} key={"variable" + variable.id} postbackAction={updateVariable} />
                );
                setType({ id: 0, styleVariableContainer: getStyleByType(0) });
                break;
            case DashboardVariableType.find(type => type.name == "Input").value:
                setRender(
                    <DashboardInput data={variable} activeError={setHasError} postbackAction={updateVariable} />
                )
                setType({ id: 1, styleVariableContainer: getStyleByType(1) });
                break;
            case DashboardVariableType.find(type => type.name == "Dropdown").value:
                setRender(
                    <DashboardDropdown data={variable} postbackAction={updateVariable} />
                )
                setType({ id: 2, styleVariableContainer: getStyleByType(2) });
                break;
            case DashboardVariableType.find(type => type.name == "Button").value:
                setRender(
                    <DashboardButton data={variable} bot={bot} postbackAction={updateVariable} dashboardsChannelsLinks={dashboard_channel.dashboards_channels_links}  />
                )
                setType({ id: 3, styleVariableContainer: getStyleByType(3) });
                break;
            case DashboardVariableType.find(type => type.name == "Number").value:
                setRender(
                    <DashboardNumber data={variable} bot={bot} postbackAction={updateVariable} />
                )
                setType({ id: 4, styleVariableContainer: getStyleByType(4) });
                break;
            default:
                return 'foo';
        }
    }

    const updateVariable = async (value) => {
        let dataToSend = variable
        dataToSend.value = value;
        dataToSend.dashboard_channel_id = dashboard_channel.id;
        dataToSend.block_id = variable.dashboard_block_id;
        dataToSend.is_updating_value = true;
        const [response, errors] = variable.origin == 0 ? await updateDashboardVariableShared(variable.id, dataToSend) : await editVariable(variable.id, dataToSend);
        if (errors != null) {
            console.log(errors)
            return;
        }
        //modal.resolve(response);
        toast.success('Variable\'s value changed', 'The value of the variable " ' + response.label + ' " has been changed !');
        postbackAction();
        //onClose();
    }

    const modifyPositionVariable = async (pos) => {
        if (pos < 0 || pos >= index.max) return;
        let dataToSend = { "position": pos }
        const [response, errors] = await updatePositionVariable(variable.id, dataToSend)
        if (errors != null) {
            console.log(errors)
            return;
        }
        //modal.resolve(response);
        //toast.success('Variable\'s position changed', 'The position of the variable " ' + response.label + ' " has been changed !');
        postbackAction();
    }
    const showRemoveVariableModal = async () => {
        await NiceModal.show(ApiModal, {
            title: "Delete Variable",
            body: "Do you really want to delete the variable : \" " + variable.label + " \" ?",

            api: {
                request: deleteVariable,
                param: [variable.id]
            },

            buttons: [
                { className: 'validate', label: 'Cancel' },
                { className: 'cancel', label: 'Delete', type: 'submit' },
            ],
            confirm: {
                name: variable.label,
                fieldName: "this variable",
            }
        });
        toast.success("Variable removed", 'The variable "' + variable.label + ' "has been removed ! ');
        postbackAction();

    };

    useEffect(() => {
        analysisVariable();
    }, [variable]);

    useEffect(() => {
        if (variable.position == null) {
            modifyPositionVariable(index.current);
        }
    }, [])

    const showEditVariableModal = () => NiceModal.show(DashboardVariableFormModal, {
        block_id: variable.dashboard_block_id,
        postbackAction: postbackAction,
        bot: bot,
        variable: variable,
        dashboardChannel : dashboard_channel,
    });

    const getStyleByType = (id) => {
        let res = null;
        if (id != 1) {
            res = { paddingTop: "10px", paddingBottom: "10px", minHeight: "60px" }
        }
        if (id == 2) {
            res = { paddingTop: "15px", paddingBottom: "15px", alignItems: "normal", minHeight: "60px" }
        }
        return res;
    }
    //console.log(variable);
    return (
        <>
            <div className={variable.bot_variable_id == null && variable.type != 3 ? "error_bot_variable_doesnt_exist" : ""} onMouseEnter={() => setHoverVariable(true)} onMouseLeave={() => setHoverVariable(false)}>
                <div className={"dashboard_variable_container " + (className ? className : "")} style={type.styleVariableContainer}>
                    <div className={ "position_variable_dashboard " + (variable.position == index.max - 1 || variable.position == 0 ? "position_arrow_dropdown" : "") }>
                        {
                            hoverVariable == true && isAdmin(access) && variable.origin != 0 &&
                            <>
                                {
                                    variable.position != 0 &&
                                    <i className="fas fa-chevron-up" style={{ marginBottom: variable.position != index.max - 1 ? "15px" : "" }} aria-hidden="true" onClick={() => modifyPositionVariable(variable.position - 1)} />
                                }
                                {
                                    variable.position != index.max - 1 &&
                                    <i className="fas fa-chevron-down" aria-hidden="true" onClick={() => modifyPositionVariable(variable.position + 1)} />
                                }
                            </>
                        }
                    </div>

                    <div className="dashboard_variable_title">
                        {
                            variable.conditions.length > 0 && isAdmin(access) && variable.printedInView == true &&
                            <i className="fas fa-eye" style={{color : "var(--main)", marginRight: "15px"}}></i>

                        }
                        {
                            variable.conditions.length > 0 && isAdmin(access) && variable.printedInView == false &&
                            <i className="fas fa-eye-slash" style={{color : "var(--main)", marginRight: "15px"}}></i>

                        }
                        {variable.label}

                        {
                            variable.information != null && variable.information.replace(/\s/g, '').length > 0 &&
                            <>
                                <Tooltip classNameContainer="right" text={variable.information}></Tooltip>
                            </>
                        }
                        {
                            type.id == 1 && hasError == true &&
                            <div className="error_message"></div>
                        }

                    </div>

                    <div className="dashboard_variable_content" style={{ marginTop: variable.type == 2 ? "15px" : "" }}> {render}</div>
                    <div>
                        <div className="dashboard_buttonActions_container" style={{ marginTop: variable.type == 2 ? "15px" : "" }}>
                            {
                                !isClient(access) &&
                                <>
                                    <i className="fas fa-edit dashboard_editAction dashboard_buttonAction" aria-hidden="true" onClick={() => showEditVariableModal()} />
                                    <i className="fas fa-trash dashboard_deleteAction dashboard_buttonAction" aria-hidden="true" onClick={() => showRemoveVariableModal()} />
                                </>
                            }
                        </div>
                        {
                            type.id == 1 && hasError == true &&
                            <div className="error_message"></div>
                        }
                    </div>
                </div>
                {
                    variable.bot_variable_id == null && variable.type != 3 &&
                    <div>

                        <div className="error_message error_message_bot_variable_doesnt_exist" >
                            {
                                isAdmin(access) &&
                                <> This variable doesn't exist anymore in the bot <span style={{ fontWeight: "bold" }}> {bot.name}</span>, please remove this row from the dashboard or restore the variable</>
                            }
                            {
                                isClient(access) &&
                                <> This variable doesn't exist anymore, contact your administrator to remove this case of restore the variable if it's a mistake.</>

                            }
                        </div>

                    </div>
                }
            </div>
        </>
    );
}

export default DashboardVariable;